import * as colors from './ItemColors';

export const THEME_1 = {
  class: `tcm`,
  playerIconColor: colors.GREEN,
  borderColor: colors.GREEN,
  textColor: colors.BLACK,
  gridColor: colors.GREY,
  playerInnerFill: colors.WHITE,
};

export const THEME_2 = {
  class: `ussf`,
  playerIconColor: colors.RED,
  borderColor: colors.WHITE,
  textColor: colors.BLACK,
  gridColor: colors.WHITE,
  playerInnerFill: `#A7CD95`,
};



// WEBPACK FOOTER //
// ./library/app/components/Diagram/Themes.js